import { documentStorageApi } from '.';
import { TAG_TYPES } from 'types/services';
import type { FileResponse, FileUrlResponse } from 'types';
import type { GoogleDriveFileResponse } from 'types/documentStorage';

export const googleCloudStorageService = documentStorageApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getFiles: builder.query<{ files: FileResponse[] }, { ids: string[] }>({
      query: ({ ids }) => ({
        url: 'Files',
        method: 'POST',
        body: { fileIds: ids },
      }),
      providesTags: [TAG_TYPES.FILES],
    }),
    getFileUrl: builder.query<FileUrlResponse, { id: string }>({
      query: ({ id }) => ({
        url: `Files/${id}/Url`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.FILES],
    }),
    getFilesUrls: builder.query<{ fileUrls: FileUrlResponse[] }, { ids: string[] }>({
      query: ({ ids }) => ({
        url: 'Files/Url',
        method: 'POST',
        body: {
          fileIds: ids,
        },
      }),
      providesTags: [TAG_TYPES.FILES],
    }),
    uploadFile: builder.mutation<
      FileResponse,
      {
        name: string;
        data: FormData;
      }
    >({
      query: ({ data, name }) => ({
        url: 'GoogleCloudStorageFiles',
        method: 'POST',
        body: data,
        params: {
          name,
        },
      }),
      invalidatesTags: [TAG_TYPES.FILES],
    }),
    uploadGoogleDriveFile: builder.mutation<
      GoogleDriveFileResponse,
      {
        name: string;
        embedUrl: string;
        documentId: string;
      }
    >({
      query: (body) => ({
        url: 'GdriveFiles',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TAG_TYPES.FILES],
    }),
    deleteFile: builder.mutation<
      unknown,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: 'GoogleCloudStorageFiles',
        method: 'DELETE',
        params: {
          id,
        },
      }),
      invalidatesTags: [TAG_TYPES.FILES],
    }),
  }),
});
export const {
  useGetFilesQuery,
  useGetFileUrlQuery,
  useGetFilesUrlsQuery,
  useLazyGetFilesUrlsQuery,
  useLazyGetFilesQuery,
  useUploadFileMutation,
  useUploadGoogleDriveFileMutation,
  useDeleteFileMutation,
} = googleCloudStorageService;
